import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { devLog } from "utils/devLog";

const policyMap = new Map();

export default function DRIVOMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [firstName, setFirstName] = useState(props.context.state.FirstName);
  const [lastName, setLastName] = useState(props.context.state.LastName);
  const [firstNameInput, setFirstNameInput] = useState(props.currState.MemberLookup.firstName);
  const [lastNameInput, setLastNameInput] = useState(props.currState.MemberLookup.lastName);
  const [partnerCode, setPartnerCode] = useState(props.context.state.localGroup);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [displaySelectionComponent, setDisplaySelectionComponent] = useState(false);
  const [noContactFound, setNoContactFound] = useState(false);

  // useEffect(() => {
  //   //devLog(props);
  //   onSubmit();
  // }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
      setDisplaySelectionComponent(success);
    }
  };

  const onMemberInfo = (memberInfo, contacts) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contacts);
      //devLog("memberInfo: " + memberInfo);
    }
  };

  //select Contact function, set selectContact to contacts => input
  //
  const onSelect = (sc) => {
    //devLog("selected Contact: ", sc);
    setSelectedContact(sc);
    onMemberInfo(memberInfo, sc);
    if (sc === undefined) {
      //devLog("selected undefined Contact: ", props.context.state.FirstName + " " + props.context.state.LastName);
      setFirstName(props.context.state.FirstName);
      setLastName(props.context.state.LastName);
    } else {
      setFirstName(sc.firstName);
      setLastName(sc.lastName);
      //devLog("selected defined Contact: ", sc.firstName + " " + sc.lastName);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        lastName: lastNameInput,
        partnerCode: partnerCode,
        searchType: searchType,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        //devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.memberInfo.contacts === "object") {
          if (!json.data.error) {
            setContacts(json.data.memberInfo.contacts);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setMemberInfo([]);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.memberInfo === "object") {
          if (!json.data.error) {
            setContacts([]);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            setNoContactFound(true);
            onLoad(true);
          } else {
            setContacts([]);
            setMemberInfo([]);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setMemberInfo([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts([]);
          setMemberInfo([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  useEffect(() => {
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, [contacts]);

  const checkDuplicateContact = (firstName, lastName) => {
    if (firstName !== "" && lastName !== "") {
      contacts.map((con, index) => {
        if (
          con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
          con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
        ) {
          setCheckDuplicateName(true);
        }
        return checkDuplicateContact;
      });
    }
  };

  const formControlStyle = {
    backgroundColor: "white",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "10px",
    paddingBottom: "10px",
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo && displaySelectionComponent ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <>
                <div className="policy-info-line">
                  <b>{t("description.ConfirmCustomerLastName")}:</b> {memberInfo.lastName}
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.RentalAgreementNumber")}:</b> {memberInfo.memberNumber}
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.ConfirmVehicleYear")}:</b> {memberInfo.year}
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.ConfirmVehicleMake")}:</b> {memberInfo.make}
                </div>
                <hr />
                <div className="policy-info-line">
                  <b>{t("description.ConfirmVehicleModel")}:</b> {memberInfo.model}
                </div>
                <hr />
              </>
            </div>
          </div>
        ) : (
          <></>
        )}

        {contacts.length > 0 && !error && displaySelectionComponent && (
          <>
            <FormControl className="existing-driver-FormControl" fullWidth={true} style={formControlStyle}>
              <h4 id="demo-radio-buttons-group-label">{t("description.ContactInformationHeader")}</h4>
              <hr />
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                className="existing-driver-radio"
              >
                {contacts.map((contact, index) => {
                  return (
                    <FormControlLabel
                      value={contact}
                      key={index}
                      control={<Radio />}
                      label={contact.firstName + " " + contact.lastName}
                      onClick={(e) => {
                        onSelect(contact);
                      }}
                      checked={selectedContact === contact ? "selected" : ""}
                      sx={{ fontWeight: "bold" }}
                    />
                  );
                })}
              </RadioGroup>
              <hr />
            </FormControl>
          </>
        )}
        {(!checkDuplicateName || noContactFound) && !error && displaySelectionComponent ? (
          <>
            <FormControl className="existing-driver-FormControl" fullWidth={true} style={formControlStyle}>
              {/* <hr /> */}
              <h4 id="demo-radio-buttons-group-label">{t("description.AddContactInformationHeader")}</h4>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                className="existing-driver-radio"
              >
                <FormControlLabel
                  control={<Radio />}
                  label={props.currState.FirstName + " " + props.currState.LastName}
                  onClick={(e) => {
                    onSelect(undefined);
                  }}
                  checked={selectedContact === undefined}
                  sx={{ fontWeight: "bold" }}
                />
              </RadioGroup>
            </FormControl>
          </>
        ) : (
          <></>
        )}
      </div>

      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
